import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Admin authentication uses secure httpOnly cookies (see adminFetch), never a
// token in localStorage. The public `api` instance carries no auth header.
export const api = axios.create({ baseURL: API });

export const openStylistChat = () =>
  window.dispatchEvent(new Event("open-stylist-chat"));

export const APP_STORE_URL =
  "https://apps.apple.com/gb/app/senior-stylist/id6757600475";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.seniorstylist.app";

export const goToAppStore = () => {
  // Fire-and-forget analytics. Must NEVER block the store redirect below, so a
  // failure is swallowed but still surfaced to the console for observability.
  try { require("./analytics").trackEvent("cta_click", "app_store"); }
  catch (e) { console.debug("app_store analytics skipped:", e?.message || e); }
  const ua = navigator.userAgent || navigator.vendor || "";
  const isAndroid = /android/i.test(ua);
  const url = isAndroid ? PLAY_STORE_URL : APP_STORE_URL;
  window.open(url, "_blank", "noopener,noreferrer");
};
